import { Map } from 'immutable';

import { setDescriptionErrors } from '../product/errors';
import { getOversetValue } from '../product/checkAttribute';

import { ERROR, OPERATIONS, OVERSET, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { SHOPIFY } from '../../constants/channels';
import { FORM } from '../../constants/forms';

export function editDescription({ product: source, value }) {
  let product = source;
  const operations = [];
  const channel = product.get('channel');

  product = setDescriptionErrors({ product: product.setIn([FORM.DESCRIPTION, VALUE], value) });

  switch (channel) {
    case SHOPIFY: {
      product = setDescriptionErrors({ product: source.setIn([FORM.DESCRIPTION, VALUE], value) });

      if (!product.getIn([FORM.DESCRIPTION, ERROR])) {
        operations.push(Map({ type: OPERATIONS[channel].DESCRIPTION, value }));

        if (product.getIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, OVERSET])) {
          const metaDescription = getOversetValue({ attribute: ATTRIBUTE.META_DESCRIPTION, product });
          product = product.setIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, VALUE], metaDescription);
          operations.push(Map({ type: OPERATIONS[SHOPIFY].META_DESCRIPTION, value: metaDescription }));
        }
      }

      break;
    }

    default: {
      product = setDescriptionErrors({ product: source.setIn([FORM.DESCRIPTION, VALUE], value) });

      if (!product.getIn([FORM.DESCRIPTION, ERROR])) {
        operations.push(Map({ type: OPERATIONS[channel].DESCRIPTION, value }));
      }

      break;
    }
  }

  return { product, operations };
}
